import axios from 'axios';
// eslint-disable-next-line import/no-unresolved,import/no-extraneous-dependencies, import/extensions
import config from 'config';
import Vue from 'vue';

const qs = require('qs');

const state = {
	issues: {},
	issue: '',
};

const actions = {
	getIssues: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios
			.get(`${config.api}/politician/${payload.userId}/issue?api_key=${
				payload.apiKey
			}&filter=all&page=${payload.page}&results=${payload.results}`)
			.then(
				(response) => {
					resolve(response);
					commit('setIssues', response.data);
				},
				(error) => {
					reject(error);
					commit('setError', error.response.data);
					commit('statusCheck', error.response.status);
				},
			);
	}),
	toggleReadIssue: ({ commit, rootState }, payload) => {
		const read = payload.read;
		return new Promise((resolve, reject) => {
			axios.put(`${config.api}/politician/${rootState.userId}/issue/${payload.issueId}?api_key=${rootState.apiKey}`, null, { params: { read } })
				.then((response) => {
					resolve(response);
					commit('toggleIssueReadingState', payload.issueId);
					commit('setSuccess');
				})
				.catch((error) => {
					reject(error);
					commit('setError', error.response.data, { root: true });
					commit('statusCheck', error.response.status);
				});
		});
	},
	// toggleReadIssue: ({ commit, rootState }, payload) =>
	// 	new Promise((resolve, reject) => {
	// 		const newPayload = Object.assign({}, payload);
	// 		delete newPayload.issueId;
	// 		const formData = new FormData();
	// 		Object.keys(newPayload).forEach(key => formData.append(key, newPayload[key]));
	// 		axios({
	// 			method: 'PUT',
	// 			headers: { 'Content-Type': 'multipart/form-data' },
	// 			url: `${config.api}/politician/${rootState.userId}/issue/${payload.issueId}?api_key=${rootState.apiKey}`,
	// 			data: formData,
	// 		}).then((response) => {
	// 			resolve(response);
	// 			commit('setSuccess');
	// 		}).catch((error) => {
	// 			reject(error);
	// 			commit('setError', error.response.data, { root: true });
	// 			commit('statusCheck', error.response.status);
	// 		});
	// 	}),
	getIgnoredIssues: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios
			.get(`${config.api}/politician/${payload.userId}/issue?api_key=${
				payload.apiKey
			}&filter=deleted&page=${payload.page}&results=${payload.results}`)
			.then(
				(response) => {
					resolve(response);
					commit('setIgnoredIssues', response.data);
				},
				(error) => {
					reject(error);
					commit('setError', error.response.data);
					commit('statusCheck', error.response.status);
				},
			);
	}),

	getClosedIssues: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios
			.get(`${config.api}/politician/${payload.userId}/issue?api_key=${
				payload.apiKey
			}&filter=replied&page=${payload.page}&results=${payload.results}`)
			.then(
				(response) => {
					resolve(response);
					commit('setClosedIssues', response.data);
				},
				(error) => {
					reject(error);
					commit('setError', error.response.data);
					commit('statusCheck', error.response.status);
				},
			);
	}),

	geIssuebyid: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios
			.get(`${config.api}/politician/${payload.userId}/issue/${payload.issueId}?api_key=${payload.apiKey}`)
			.then((response) => {
				resolve(response);
				commit('responseIssues', response.data);
			}).catch((error) => {
				reject(error);
				commit('statusCheck', error.response.data);
			});
	}),
	responseIssue: ({ commit, rootState }, payload) =>
		new Promise((resolve, reject) => {
			axios({
				method: 'PUT',
				headers: { 'Content-Type': 'multipart/form-data' },
				url: `${config.api}/politician/${rootState.userId}/issue/${payload.get('issueId')}?api_key=${rootState.apiKey}`,
				data: payload,
			}).then((response) => {
				resolve(response);
				commit('setSuccess');
			}).catch((error) => {
				reject(error);
				commit('setError', error.response.data, { root: true });
				commit('statusCheck', error.response.status);
			});
		}),
	deleteMessage: ({ commit, rootState }, payload) =>
		new Promise((resolve, reject) => {
			axios({
				method: 'PUT',
				url: `${config.api}/politician/${rootState.userId}/issue/batch-delete?ids=${payload.get('ids')}&api_key=${rootState.apiKey}`,
			}).then((response) => {
				resolve(response);
				commit('setSuccess');
			}).catch((error) => {
				reject(error);
				commit('setError', error.response.data, { root: true });
				commit('statusCheck', error.response.status);
			});
		}),
	// This doesn't exist on the API side yet, only
	// the soft delete is available by now
	permaDeleteIssue: ({ commit, rootState }, payload) =>
		new Promise((resolve, reject) => {
			axios({
				method: 'PUT',
				headers: { 'Content-Type': 'multipart/form-data' },
				url: `${config.api}/politician/${rootState.userId}/issue/batch-delete?api_key=${rootState.apiKey}`,
				data: payload,
			}).then((response) => {
				resolve(response);
				commit('setSuccess');
			}).catch((error) => {
				reject(error);
				commit('setError', error.response.data, { root: true });
				commit('statusCheck', error.response.status);
			});
		}),
};

const mutations = {
	setIssues: (state, payload) => {
		state.issues = payload;
	},
	setIgnoredIssues: (state, payload) => {
		state.issues = payload;
	},
	setClosedIssues: (state, payload) => {
		state.issues = payload;
	},
	responseIssues: (state, payload) => {
		state.issue = payload;
	},
	statusCheck: (state, payload) => {
		if (payload === 403) {
			sessionStorage.setItem('statusCode', payload);
		}
	},
	toggleIssueReadingState: (state, id) => {
		if (state.issues.issues && state.issues.issues.length) {
			const issueIndex = state.issues.issues.findIndex(x => String(x.id) === String(id));

			if (issueIndex >= 0) {
				const issue = state.issues.issues[issueIndex];
				issue.read = issue.read === 1
					? 0
					: 1;
				Vue.set(state.issues.issues, issueIndex, issue);
			}
		}
	},
};

export default {
	state,
	mutations,
	actions,
};



// WEBPACK FOOTER //
// ./_source/javascripts/modules/issue/store.js